<template>
  <span class="block rounded-full px-4 py-1.5 text-sm bg-ocean-800 text-ocean-300 uppercase tracking-wide">
    {{ title }}
  </span>
</template>

<script>
export default {
  name: 'VetsterCategoryBadge',

  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
